<template>
    <div class="purpose" :style="`background: url(${backgroundImg}) no-repeat`">
        <div class="purpose-tips">还没看到想要的可视化项目？请告诉我们</div>
        <div class="purpose-tips-small">我们为您提供专业2D/3D可视化项目设计开发实施服务，同时保证您的信息不会被泄露</div>
        <el-button class="show-btn" type="primary" @click="handleClickPurpose">将你的需求告诉我们</el-button>
        <RequestForm v-if="showRequestForm" :showRequestForm.sync="showRequestForm"/>
    </div>
</template>

<script>
    import { getBannerURL } from '@/api/common';
    import RequestForm from './RequestForm';
    export default {
        components: {
            RequestForm,
        },
        name: 'RequestPurpose',
        data: () => ({
            showRequestForm: false,
            backgroundImg: require('@/assets/images/service-bg.png'), // 背景图
        }),
        mounted() {
            this.getBackgroundImg();
        },
        methods: {
            /**
             * 点击提交需求
             */
            handleClickPurpose() {
                this.showRequestForm = true;
            },
            /**
             * 获取背景图
             */
            getBackgroundImg() {
                getBannerURL(9).then(({ data }) => {
                    if (data && data[0]) {
                        this.backgroundImg = data[0].logo;
                    }
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
.purpose {
    margin-bottom: 95px;
    padding: 110px 0;
    background-size: 100% !important;
    color: #fff;
    text-align: center;
    &-tips {
        font-size: 46px;
        &-small {
            margin: 20px 0 60px 0;
            font-size: 18px;
        }
    }
    /deep/ .show-btn.el-button--primary {
        padding: 20px 100px;
        background: #2072ec;
        border: none;
        font-size: 24px;
        letter-spacing: 2px;
        &:hover {
            border: none;
            background: #2681f1;
            box-shadow: 0 0 30px rgba(50, 146, 241, .15);;
        }
    }
}
// 小屏
@include mq($small) {
  .purpose {
    margin-bottom: 90px;
    padding: 70px 0;
    &-tips {
        font-size: 40px;
        &-small {
            margin: 15px 0 40px 0;
        }
    }
  }
}
</style>
